import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import useActionWithDisabled from 'src/react/helpers/useActionWithDisabled';
import daysToCompletion from 'src/react/helpers/days_to_completion';

// Components
import Icon from 'src/react/components/icon/Icon';
import { taskShape } from 'src/api/task';

const taskProps = {
  task: taskShape,
  deleteAction: PropTypes.func,
  completeAction: PropTypes.func,
  learnMoreAction: PropTypes.func
};

const Task = (props) => {
  const { task, deleteAction, completeAction, learnMoreAction } = props;
  const isCompleted = task.completed_at !== null;
  const { isDisabled, wrapAction } = useActionWithDisabled();

  return (
    <div
      data-testid="recommendations_task"
      className="Recommendations-Task p-2 sm:p-4 mb-3 text-left rounded-lg relative"
    >
      <button
        className="absolute flex top-0 right-0 p-1 m-1 sm:my-4 sm:mx-3 cursor-pointer hover:bg-gray-10"
        style={isDisabled ? { opacity: 0.1 } : {}}
        onClick={wrapAction(deleteAction, task)}
        data-testid="task_delete_button"
      >
        <Icon name="close" />
      </button>
      <h2 className="font-semibold leading-none text-6 sm:text-8 mr-4">
        {task.title}
      </h2>
      <p className="RecommendationsTask-description text-4 text-gray-70">
        {task.summary}{' '}
        <span
          className="font-semibold text-blue-40 cursor-pointer"
          onClick={wrapAction(learnMoreAction, task)}
          onKeyUp={wrapAction(learnMoreAction, task)}
          role="button"
          tabIndex="0"
        >
          Learn More
        </span>
      </p>
      {task.days_to_completion ? (
        <p className="mb-2 text-4 text-gray-70">
          Complete in{' '}
          <span className="font-semibold">
            {daysToCompletion(task.days_to_completion)}
          </span>
          .
        </p>
      ) : null}
      <div className="flex items-start">
        <button
          onClick={wrapAction(completeAction, task)}
          className="w-full sm:w-auto rds-Button rds-Button--large"
          disabled={isCompleted || isDisabled}
        >
          Mark as Complete
        </button>
      </div>
    </div>
  );
};

Task.propTypes = taskProps;

export default Task;
